import React from "react";

import { AssessmentIcon, MemberProfileActivityEntry } from "../../../component-library";
import { ICON_SIZES, ICON_TYPES } from "../../../constants/icons";

const AssessmentActivity = (props) => {
  const { keyContent, localCreatedTime } = props;
  const { completed_by } = keyContent;

  return (
    <MemberProfileActivityEntry
      headerClassName="apti-MemberProfileActivityEntry__Header__Primary"
      iconAlt="AssessmentCompletedIcon"
      iconSrc="icons/assessment-icon-primary.svg"
      localDateTime={localCreatedTime}
      subTitle={`Completed by ${completed_by}`}
      title="Clinical Assessment Completed"
    />
  );
};

const GenericAssessmentActivity = (props) => {
  const { keyContent, timestamp } = props;
  const { assessment_type, status } = keyContent;

  let response = <></>;

  switch (status) {
    case "assigned":
      response = (
        <MemberProfileActivityEntry
          headerClassName="apti-MemberProfileActivityEntry__Header__Primary"
          iconComponent={
            <AssessmentIcon
              className="apti-MemberProfileActivityEntry__ContentContainer__Icon GenericAssessmentActivity-icon"
              iconSize={ICON_SIZES.LARGE}
              iconType={ICON_TYPES.CIRCLE}
            />
          }
          localDateTime={timestamp}
          subTitle={`The ${assessment_type} was assigned`}
          title={`${assessment_type} Assigned`}
        />
      );
      break;

    case "in_progress":
      response = (
        <MemberProfileActivityEntry
          headerClassName="apti-MemberProfileActivityEntry__Header__Primary"
          iconComponent={
            <AssessmentIcon
              className="apti-MemberProfileActivityEntry__ContentContainer__Icon GenericAssessmentActivity-icon"
              iconSize={ICON_SIZES.LARGE}
              iconType={ICON_TYPES.CIRCLE}
            />
          }
          localDateTime={timestamp}
          subTitle={`The ${assessment_type} was started`}
          title={`${assessment_type} Started`}
        />
      );
      break;

    case "completed":
      response = (
        <MemberProfileActivityEntry
          headerClassName="apti-MemberProfileActivityEntry__Header__Primary"
          iconComponent={
            <AssessmentIcon
              className="apti-MemberProfileActivityEntry__ContentContainer__Icon GenericAssessmentActivity-icon"
              iconSize={ICON_SIZES.LARGE}
              iconType={ICON_TYPES.CIRCLE}
            />
          }
          localDateTime={timestamp}
          subTitle={`The ${assessment_type} was completed`}
          title={`${assessment_type} Completed`}
        />
      );
      break;

    default:
      break;
  }

  return response;
};

export default AssessmentActivity;
export { GenericAssessmentActivity };
